import { createSelector } from 'reselect';


export function getNotifications(state) {
  return state.notifications;
}

export function getNotificationById(state, notificationId) {
  return getNotifications(state).get(notificationId);
}


//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentNotification = createSelector(
  getNotifications,
  notifications => notifications.get(notifications.get('notificationId'))
);
